export default __webpack_public_path__ + "static/media/All_Products.7ff567c6.jpeg";